<template>
    <div class="res">
        <transition name="fade-slide">
            <nav class="names centered" v-show="showNav" :style="{ top: navTopPosition + 'px' }">
                <ul ref="names_scroll">
                    <li v-for="ent in selectedEnts" :key="ent.id">
                        <p>{{ ent.company_name }}</p>
                    </li>
                </ul>
            </nav>
        </transition>
        <div class="card_b active">
            <div class="head">
                <h3>להלן היזמים שבחרת להשוואה סופית</h3>
                <div class="switch_con">
                    
                    <div class="theme-switch-wrapper mid">
                        <span >ציון מפורט</span>
                        <label class="theme-switch">
                            <input type="checkbox" v-model="showDetailedGrades">
                            <span class="slider round"></span>
                        </label>
                        <span>ציון כללי</span>
                    </div>
                </div>
            </div>
            <div class="content">
                <div v-if="showDetailedGrades" class="grade-legend">
                    <div class="legend-item" v-for="(grade, index) in gradeTypes" :key="index">
                        <span class="color-box" :style="{ background: grade.color }">
                            <span class="label">{{ grade.name }}</span>
                        </span>
                    </div>
                </div>
                <div class="scroll-container" ref="scrollContainer">
                    <div class="stats" ref="stats" @scroll="handleScroll">
                        <div class="data" v-if="selectedEnts">
                            <ul>
                                <li :class="{show_trans: showTrans}" v-for="ent in selectedEnts" :key="ent.id">
                                    <template v-if="showDetailedGrades">
                                        <div class="scales_con">
                                            <div 
                                                v-for="(gradeType, index) in gradeTypes" 
                                                :key="index"
                                                :style="{
                                                    '--grade': getGradeValue(ent, gradeType.name) + 'px',
                                                    'background': gradeType.color
                                                }"
                                                class="grade-bar"
                                            ></div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="scales_con">
                                            <span class="grade_number">{{ calculateMainGrade(ent) }}</span>
                                            <div class="main_grade" :style="'--grade: ' + calculateMainGrade(ent) + 'px;'"></div>
                                        </div>
                                    </template>
                                    <p class="name" v-text="ent.company_name"></p>
                                </li>
                            </ul>
                        </div>
                        <div class="num_line">
                            <span class="line"></span>
                            <p class="num">100</p>
                        </div>
                        <div class="num_line">
                            <span class="line"></span>
                            <p class="num">80</p>
                        </div>
                        <div class="num_line">
                            <span class="line"></span>
                            <p class="num">60</p>
                        </div>
                        <div class="num_line">
                            <span class="line"></span>
                            <p class="num">40</p>
                        </div>
                        <div class="num_line">
                            <span class="line"></span>
                            <p class="num">20</p>
                        </div>
                        <div class="num_line">
                            <span class="line"></span>
                            <p class="num">0</p>
                        </div>
                    </div>
                </div>
                
                <p class="note">**הציון הוא מ 0-100</p>
            </div>
        </div>
    </div>
</template>

<script>
import { grabScrollMixin } from '@/mixins/grabScroll';

export default {
    name: 'ComparisonTable',
    mixins: [grabScrollMixin],
    props: {
        selectedEnts: {
            type: Array,
            default: () => []
        },
        showTrans: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDetailedGrades: true,
            showNav: false,
            navTopPosition: 100,
            gradeTypes: []
        }
    },
    methods: {
        calculateMainGrade(ent) {
            // If we have grades array, calculate average from it
            if (ent.grades && ent.grades.length > 0) {
                const sum = ent.grades.reduce((total, grade) => total + grade.grade, 0);
                return Math.round(sum / ent.grades.length);
            }
            
            // Fallback to old calculation if no grades array
            return Math.round((ent.settings_grade + ent.tech_grade + ent.legal_grade) / 3);
        },
        getGradeValue(ent, gradeName) {
            // Find the grade by name in the grades array
            if (ent.grades && ent.grades.length > 0) {
                const gradeItem = ent.grades.find(g => g.name === gradeName);
                if (gradeItem) {
                    return gradeItem.grade;
                }
            }
            
            return 0;
        },
        handleScroll() {
            if (!this.$refs.stats) return;
            
            const scrollLeft = this.$refs.stats.scrollLeft;
            
            // Update the names scroll position
            if (this.$refs.names_scroll) {
                this.$refs.names_scroll.scrollLeft = scrollLeft;
            }
            
            // Emit event for parent components
            this.$emit('stats-scroll', scrollLeft);
        },
        handleTableScroll(scrollLeft) {
            // Update stats scroll position when table scrolls
            if (this.$refs.stats) {
                this.$refs.stats.scrollLeft = scrollLeft;
            }
            
            // Update the names scroll position
            if (this.$refs.names_scroll) {
                this.$refs.names_scroll.scrollLeft = scrollLeft;
            }
        },
        handlePageScroll() {
            if (!this.$refs.scrollContainer) return;
            
            const containerRect = this.$refs.scrollContainer.getBoundingClientRect();
            const containerTop = containerRect.top;
            const containerBottom = containerRect.bottom;
            const windowHeight = window.innerHeight;

            // Show nav when container is in view and we're scrolling through it
            this.showNav = containerTop < 100 && containerBottom > windowHeight;
            
            if (this.showNav && this.$refs.names_scroll && this.$refs.stats) {
                this.$refs.names_scroll.scrollLeft = this.$refs.stats.scrollLeft;
            }

            // Adjust nav position when reaching bottom of the container
            if (containerBottom < windowHeight) {
                this.navTopPosition = containerTop;
            } else {
                this.navTopPosition = 100;
            }
        },
        initGradeTypes() {
            console.log(this.selectedEnts);
            if (this.selectedEnts.length > 0 && this.selectedEnts[0].grades && this.selectedEnts[0].grades.length > 0) {
                // Use the grades array from the first entity
                this.gradeTypes = this.selectedEnts[0].grades.map(grade => ({
                    name: grade.name,
                    color: grade.color
                }));
            } 
            // else {
            //     // Create sample data with random colors for testing/fallback
            //     this.gradeTypes = [
            //         { name: 'ציון מסחרי', color: 'var(--settings-color)' },
            //         { name: 'ציון טכני', color: 'var(--tech-color)' },
            //         { name: 'ציון משפטי', color: 'var(--legal-color)' }
            //     ];

            //     // Create sample grades array for each entity if it doesn't exist
            //     this.selectedEnts.forEach(ent => {
            //         if (!ent.grades) {
            //             ent.grades = [
            //                 { name: 'ציון מסחרי', grade: ent.settings_grade || Math.floor(Math.random() * 100) },
            //                 { name: 'ציון טכני', grade: ent.tech_grade || Math.floor(Math.random() * 100) },
            //                 { name: 'ציון משפטי', grade: ent.legal_grade || Math.floor(Math.random() * 100) }
            //             ];
            //         }
            //     });
            // }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handlePageScroll);

        // Initialize grab scroll for stats
        const cleanupStats = this.initGrabScroll(
            this.$refs.stats, 
            () => this.handleScroll()
        );

        // Initialize grade types
        this.initGradeTypes();

        // Store cleanup functions
        this._cleanupFunctions = [cleanupStats];
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handlePageScroll);
        
        // Clean up grab scroll listeners
        if (this._cleanupFunctions) {
            this._cleanupFunctions.forEach(cleanup => cleanup && cleanup());
        }
    },
    watch: {
        selectedEnts: {
            handler() {
                this.initGradeTypes();
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.res { 
    --settings-color: #F7B3FF;
    --tech-color: #CAB3FF;
    --legal-color: #60A9FF;
    
    padding: var(--gap_xmid); position: relative;
    .content {padding-block: 60px 80px;display: flex;flex-direction: column;    align-items: flex-end;position: relative;gap: 25px;}
    .scroll-container {
        width: 100%;
        overflow: hidden;
    }
    nav.names { top: 100px; inset-inline: 0; overflow: hidden; border-radius: 50px; z-index: 10; background: var(--card_blue_bg); position: fixed; width: calc(100% - var(--gap_xmid) * 2); top: 100px; transition: all 0.3s ease;

        ul { 
            overflow-x: auto; 
            display: flex; 
            justify-content: flex-start;  
            padding-inline: 260px 60px; 
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
            &::-webkit-scrollbar { display: none; } /* Chrome, Safari and Opera */
            li { 
                width: 200px;  
                min-width: 200px; 
                align-content: center;
                p { 
                    text-align: center; 
                    color: var(--blue_ligher); 
                }
            }
        }
    }
    .stats {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: thin;
        user-select: none; /* Prevent text selection while dragging */
        cursor: grab;
        
        &:active {
            cursor: grabbing;
        }
        
        &::-webkit-scrollbar {
            height: 12px;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
            border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
        }
    }
    .stats { position: relative; padding-inline: var(--gap_xmid); padding-block: 45px 25px;     padding-bottom: 80px; display: flex; flex-direction: column; justify-content: space-between; align-items: center; gap: var(--gap_xmid);
        .data { position: absolute; inset: 0; padding-block: 12px;
            ul { width: 100%; height: 100%; display: flex; /* gap: var(--gap_mbig); */ align-items: flex-end;    padding-right: 200px;
                li { position: relative; padding-inline: var(--gap); width: 200px; min-width: 200px; min-height: 10px; height: 100%; display: flex; justify-content: center; align-items: flex-end; margin-bottom: 81px;
                    .wrapper{ transition: all 0.3s ease; height: 0px; background: var(--text_s); border-radius: var(--radius_s); width: 50%;}
                    .scales_con { width: 100%; align-items: flex-end; display: flex; opacity: 0; transition: opacity 0.3s ease;
                        .grade-bar { 
                            flex: 1; 
                            height: 0; /* Initial height is 0 */
                            transition: height 0.3s ease; 
                        }
                    }
                    &.show_trans {
                        .scales_con { 
                            opacity: 1;
                            .grade-bar {
                                height: calc(var(--grade)* 2.9); /* Animate to final height */
                            }
                        }
                    }
                    .grade_con { position: relative; top: -8px; left: 0; transform: translateY(-100%); right: 0; margin: 0 auto;}
                    .name {position: absolute; bottom: -8px; right: 50%; line-height: 1; text-align: center; transform: translate(50%, 100%); width: 85px; font-size: var(--h6); color: var(--dark_blue); }
                }
            }
        }
        .num_line { width: 100%; display: flex; align-items: center; gap: var(--gap);flex-direction: row-reverse;
            .num { width: 26px; }
            .line {flex: 1; height: 1px; background: var(--pageBG);}
        }
        
    }
    .note { font-size: 14px; color: var(--dark_blue); margin-block: 20px 10px; }
    .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .scales_con {
        position: relative;
        flex: 1;
        display: flex;
        .main_grade {
            flex: 1;
            height: calc(var(--grade)* 2.9);
            background: var(--dark_blue);
        }
        .grade_number {  
            border: 1px solid var(--dark_blue);
            padding: 5px;
            border-radius: 50%;
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            margin-bottom: 5px;
            font-weight: 500;
            // color: var(--dark_blue);
            color: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
        }
    }
    .grade-legend {
        position: absolute;
        left: 20px;
        top: 20px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        
        .legend-item {
            display: flex;
            align-items: center;
            
            .color-box {
                width: 120px;
                height: 30px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 10px;
                
                &.settings { 
                    background: var(--settings-color);
                }
                &.tech { 
                    background: var(--tech-color);
                }
                &.legal { 
                    background: var(--legal-color);
                }
            }
            
            .label {
                // color: var(--dark_blue);
                color: #fff;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    li.show_trans {
        .scales_con {
            opacity: 1;
        }
    }

    .fade-slide-enter-active {
        animation: slide-in 0.3s ease-out forwards;
    }
    
    .fade-slide-leave-active {
        animation: slide-out 0.3s ease-in forwards;
    }

    @keyframes slide-in {
        0% {
            transform: translateY(-100%);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes slide-out {
        0% {
            transform: translateY(0);
            opacity: 1;
        }
        100% {
            transform: translateY(-100%);
            opacity: 0;
        }
    }
}
</style> 